module.exports = __webpack_public_path__ + "img/QuickStart.34879051.png";